import { html } from '../html.js';
import { DEFAULT_PRINT_OPTIONS } from '../print-options.js';
import { t } from '../strings.js';
import { docDate, field, fields, footer, header, ltr } from './parts.js';
import { notesBlock, party, pricedLineTable, statusBadge, statusLabel, totalsBlock, } from './record-parts.js';
/**
 * SAL-02's sales order as a printed document — an order confirmation.
 *
 * Its own two facts: the EXPECTED DATE the customer was promised, and the
 * QUOTATION it was converted from, printed by code so the customer can match
 * the confirmation to the offer they accepted. Both are absent rather than
 * blank when the order has neither.
 */
export function salesOrderHtml(data, locale, company, generatedAt, generatedBy, print = DEFAULT_PRINT_OPTIONS) {
    return html `
    ${header(company, t('salesOrderTitle', locale), statusBadge(data.status, locale))}
    ${fields([
        field(t('orderNo', locale), ltr(data.code)),
        field(t('invoiceDate', locale), docDate(data.orderDate)),
        field(t('customerCode', locale), ltr(data.partnerCode)),
        field(t('status', locale), statusLabel(data.status, locale)),
        ...(data.expectedDate === null ? [] : [field(t('expectedDate', locale), docDate(data.expectedDate))]),
        ...(data.quotationCode === null ? [] : [field(t('quotationRef', locale), ltr(data.quotationCode))]),
    ])}
    ${party(t('customer', locale), data.partnerName)}
    ${pricedLineTable(data.lines, data.currency, locale, print)}
    ${totalsBlock(data, locale, print)}
    ${notesBlock(t('notes', locale), data.notes)}
    ${footer(locale, generatedAt, company.name, generatedBy)}
  `;
}
//# sourceMappingURL=sales-order.js.map